import { Alert } from 'antd'

export const ErrorBoundary = Alert.ErrorBoundary
